import { Cost } from '@r1-frontend/ui-react/components/costs';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

import ConnectedEntitiesContainer from '~/src/features/tariffBuilder/containers/ConnectedEntitiesContainer';
import EntitiesContainer from '~/src/features/tariffBuilder/containers/EntitiesContainer';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

type TOnlineCinemasProps = {
    header?: string,
    description?: string,
}

const OnlineCinemasBlock = ({ header, description }: TOnlineCinemasProps): JSX.Element => {
    const defaultDescription = <>
        Добавьте в&nbsp;ваш тариф подписки по&nbsp;специальной цене и&nbsp;смотрите кино на&nbsp;любом устройстве без рекламы.
        Первая&nbsp;&mdash; <Cost isMonthly>150</Cost>, последующие&nbsp;&mdash; <Cost isMonthly>100</Cost>
    </>;

    return (
        <>
            <TextWrapper>
                <H3>{header ? header : 'Онлайн-кинотеатры'}</H3>
                {description
                    ? <Paragraph4 $smaller dangerouslySetInnerHTML={{ __html: description }}/>
                    : <Paragraph4 $smaller>{defaultDescription}</Paragraph4>
                }
            </TextWrapper>

            <ConnectedEntitiesContainer entityName={EEntity.onlineCinemas} />
            <EntitiesContainer entityName={EEntity.onlineCinemas}/>
        </>
    );
};

export default OnlineCinemasBlock;
